import React from 'react';
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import {injectIntl} from "react-intl";
import {Tabs} from "antd";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import PlanningCalendar from "./MonthConfigurationTab";
import moment from 'moment';
import Constants from "../../../services/Constants";

const TabPane = Tabs.TabPane;

class MonthConfiguration extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      monthlyPlanning: {
        maintenancePlanning: {},
        repairPlanning: {}
      },
      planning: {},
      selectedDay: moment().format(Constants.DATE_FORMAT_API),
      selectedCalendar: "MAINTENANCE"
    }
  }

  componentDidMount() {
    this.props.dispatchFetchMonthlyPlanning(this.state.selectedDay);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchMonthlyPlanning) {
      const {maintenancePlanning = {}, repairPlanning = {}} = nextProps.fetchMonthlyPlanning.monthlyPlanning;
      Object.assign(maintenancePlanning, this.state.monthlyPlanning.maintenancePlanning);
      Object.assign(repairPlanning, this.state.monthlyPlanning.repairPlanning);
      this.setState({monthlyPlanning: {maintenancePlanning, repairPlanning}});
    }
    if (nextProps.fetchPlanningManagement && nextProps.fetchPlanningManagement.planningManagement
        && nextProps.fetchPlanningManagement.planningManagement.planning) {
      const planning = nextProps.fetchPlanningManagement.planningManagement.planning || {};
      this.setState({planning});
    }
  };

  save = () => {
    this.props.dispatchSaveMonthlyPlanning(this.state.monthlyPlanning, this.state.selectedDay);
  };

  updateDay = (day, value, planningType) => {
    const {monthlyPlanning} = this.state;
    const currentDayInPlanning = monthlyPlanning[planningType][day];
    // if new status is CLOSED or old status is closed, both plannings must be updated
    if ((value.dayStatus===Constants.DAY_CLOSED.value) || (currentDayInPlanning && currentDayInPlanning.dayStatus===Constants.DAY_CLOSED.value)) {
      monthlyPlanning.maintenancePlanning[day] = value;
      monthlyPlanning.repairPlanning[day] = value;
    } else {
      monthlyPlanning[planningType][day] = value;
    }
    this.setState(monthlyPlanning);
  };

  updateSelectedDay = (selectedDay) => {
    this.setState({selectedDay});
  };

  updateSelectedCalendar = (selectedCalendar) => {
    this.setState({selectedCalendar});
  };

  maxPerDayOfWeek = () => {
    const {planningManagement: {planning={}}} = this.props.fetchPlanningManagement;
    const maxPerDay = {};

    Object.keys(planning).forEach(key => {
      const slots = planning[key].slots || [];
      maxPerDay[key] = slots.map(s => s.maxTotalArrivals)
                            .reduce((accumulator, total) => accumulator + total, 0);

      if (this.hasTwentyFourSeven()) {
        maxPerDay[key] += planning[key].maxTwentyFourSevenArrivals || 0;
      }
    });
    return maxPerDay;
  };

  hasTwentyFourSeven = () => {
    const {fetchMainServices: {mainServices = {}}} = this.props;
    return mainServices.offering && mainServices.offering.carDropOff;
  };

  computeTotalOngoing = (date) => {
    const {monthlyPlanning: {repairPlanning, maintenancePlanning}} = this.state;
    const repairDay = repairPlanning[date] || {};
    const maintenanceDay = maintenancePlanning[date] || {};

    const repairInterventions = (Object.keys(repairDay).length > 0) ? repairDay.currentInterventions : 0;
    const maintenanceInterventions = (Object.keys(maintenanceDay).length > 0) ? maintenanceDay.currentInterventions : 0;
    return repairInterventions + maintenanceInterventions;
  };

  render() {
    const {intl:{formatMessage}, fetchMonthlyPlanning, configurationHints} = this.props;

    const maxPerDayOfWeek = this.maxPerDayOfWeek();
    const shouldConfigureWeek = configurationHints && configurationHints.includes("WEEKLY_PLANNING");

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.month-planning.title'})}
          </h2>
          <div className="box-heading__button">
            {!shouldConfigureWeek && <button onClick={this.save} type="primary" className="btn btn-sm btn-primary">{formatMessage({id:'action.save'})}</button>}
          </div>
        </header>
        {
          (fetchMonthlyPlanning.loading) ? (
            <LoadingIndicator/>
          ) : (
            <div className="box__body">
              {shouldConfigureWeek ? (
                <div className="alert alert--error">{formatMessage({id:'configuration.week-configuration.not-available'})}</div>
              ) : (
                <Tabs defaultActiveKey={this.state.selectedCalendar} type="card" onChange={this.updateSelectedCalendar}>
                  <TabPane key={"MAINTENANCE"} tab={formatMessage({id: 'section.month-planning.maintenance.title'})}>
                    <PlanningCalendar data={this.state.monthlyPlanning.maintenancePlanning}
                                      planning={this.state.planning}
                                      maxByWeekDay={maxPerDayOfWeek}
                                      computeAll={this.computeTotalOngoing}
                                      updateDay={(day, value) => this.updateDay(day, value, 'maintenancePlanning')}
                                      selectedDay={this.state.selectedDay}
                                      updateSelectedDay={this.updateSelectedDay}
                    />
                  </TabPane>
                  <TabPane key={"REPAIR"} tab={formatMessage({id: 'section.month-planning.repair.title'})}>
                    <PlanningCalendar data={this.state.monthlyPlanning.repairPlanning}
                                      planning={this.state.planning}
                                      maxByWeekDay={maxPerDayOfWeek}
                                      computeAll={this.computeTotalOngoing}
                                      updateDay={(day, value) => this.updateDay(day, value, 'repairPlanning')}
                                      selectedDay={this.state.selectedDay}
                                      updateSelectedDay={this.updateSelectedDay}
                    />
                  </TabPane>
                </Tabs>
                )}
            </div>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchMonthlyPlanning: state.fetchMonthlyPlanning,
  saveMonthlyPlanning: state.saveMonthlyPlanning,
  fetchPlanningManagement: state.fetchPlanningManagement,
  savePlanningManagement: state.savePlanningManagement,
  fetchMainServices: state.fetchMainServices,
  configurationHints: state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints,

});

const mapDispatchToProps = dispatch => ({
  dispatchFetchMonthlyPlanning: (date) => dispatch({type: 'FETCH_MONTHLY_PLANNING.REQUEST', date}),
  dispatchSaveMonthlyPlanning: (body) => dispatch({type: 'SAVE_MONTHLY_PLANNING.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(MonthConfiguration), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/planning/management/MonthConfiguration.js